import React, {Dispatch, SetStateAction, useState, useEffect} from 'react'
import {Modal} from 'react-bootstrap'
import {useMutation, useQueryClient} from 'react-query'
import {useCompanies} from '../../../../app/modules/auth/core/Companies'
import {KTSVG} from '../../../helpers'
import Select from 'react-select'
import { Company } from '../../../../app/modules/apps/company/company-list/core/_models'

type Props = {
  show: boolean
  handleClose: () => void
}



const CompanySwitchModal: React.FC<Props> = ({show, handleClose}) => {
  const queryClient = useQueryClient()
  const {defaultCompany, companies, updateDefaultCompany} = useCompanies()
  const [selectedCompany, setselectedCompany] = useState({
    value: '',
    label: '',
  });
  const [options, setoptions]:any = useState([]);


  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      backgroundColor: 'transparent',
      borderColor: '#4a5568', // Adjust the border color for better visibility
      boxShadow: 'none', // Remove the box shadow
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#4a5568' : '#fffff', // Adjust the background color for focused and non-focused options
      color: state.isFocused ? 'white' : 'black', // Adjust the text color for focused and non-focused options
    }),
  }

  useEffect(() => {
    const fetchUsers = async () => {
      try {

        var data = companies.map((item:any) => ({
          value: item.company_id,
          label: item.company_name,
        }));
        setoptions(data);
        setselectedCompany({
          value: defaultCompany?.company_id ?? '',
          label: defaultCompany?.company_name ?? '',
        })
      } catch (error) {
        console.error(error)
      }
    }
    fetchUsers()
  }, [])

 

  const handleCompanyChange = (selected:any) => {
    updateDefaultCompany(selected.value)
    window.location.reload()
  };

  return (
    <Modal
    className='modal fade'
    id='kt_modal_select_location'
    data-backdrop='static'
    tabIndex={-1}
    role='dialog'
    show={show}
    dialogClassName='modal-xs mt-10'
    aria-hidden='true'
    onHide={handleClose}
  >
           <div className='px-10 mw-1000px'>

    <div className='modal-content'>
      <div className='modal-header mb-10'>
        <h5 className='modal-title'>Switch Company</h5>

        <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
          <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
        </div>
      </div>
      <form id='kt_modal_add_user_form' className='form'>
        <div className='mt-2'>
          <Select
            styles={customStyles}
            value={selectedCompany}
            onChange={handleCompanyChange}
            options={options}
          />
        </div>

        <div className='text-center pt-15'>
          {/* <button
            type='reset'
            onClick={() => handleClose()}
            className='btn btn-light me-3 mb-10'
            data-kt-users-modal-action='cancel'
          >
            Discard
          </button>

          <button type='submit' className='btn btn-primary mb-10'>Save Changes</button> */}
        </div>
        {/* end::Actions */}
      </form>
    </div>
    </div>
  </Modal>
  )
}

export {CompanySwitchModal}
